<div class="info"></div>
<div class="content" [ngClass]="{inline: inline}">{{content}}</div>